var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C13.6569 2 15 3.34315 15 5V11C15 12.6569 13.6569 14 12 14H4C2.34315 14 1 12.6569 1 11V5C1 3.34315 2.34315 2 4 2H12ZM13.0918 4.53906C12.8374 4.21246 12.3659 4.15401 12.0391 4.4082L8.46094 7.19141C8.1901 7.40205 7.80989 7.40205 7.53906 7.19141L3.96094 4.4082C3.63411 4.15401 3.16258 4.21246 2.9082 4.53906C2.65401 4.86589 2.71246 5.33742 3.03906 5.5918L6.61816 8.37598C7.43066 9.00792 8.56934 9.00792 9.38184 8.37598L12.9609 5.5918C13.2875 5.33742 13.346 4.86589 13.0918 4.53906Z",
    fill: "#00326D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.631e8d102333cc87d6d2ba65146f6906.svg";
export { ForwardRef as ReactComponent };